import { IApiErrorResponse, IToastConfig } from '@/models'
import { STORE_MODULES, ACTIONS_TOASTS } from '@/enums'

function getErrorMessage(errorResponse: IApiErrorResponse) {
    return errorResponse.data == null
        ? errorResponse.toString() // If some shit happens in code and input will be js Error
        : errorResponse.data.errorText
}

export function dispatchErrorToast(dispatch: Function, errorResponse: IApiErrorResponse): void {
    const actionType = `${STORE_MODULES.TOASTS}/${ACTIONS_TOASTS.CREATE_TOAST}`
    const toastConfig: IToastConfig = {
        type: 'error',
        message: getErrorMessage(errorResponse),
        timeout: 0,
    }

    // redirection to sign in form should be clear enough
    if (errorResponse.status === 401) return

    dispatch(actionType, toastConfig, { root: true })
}
